import React from "react";
import "./UserChat.scss";

export const UserChat = ({ message }) => {
  const d = new Date(message.timestamp || Date.now());
  const day = d.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <div className={`order-chat-bubble ${message.role}`}>
      <div className="order-chat-bubble-meta">
        <span className="order-chat-user-name">{message.name || "You"}</span>
        <span className="order-chat-time">{`${day} ${time}`}</span>
      </div>
      <div className="order-chat-bubble-inner">{message.text}</div>
    </div>
  );
};
